import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import Aliados from '../themes/aliados';
import BlogRight from '../themes/blogRight';
import Clientes from '../themes/clientes';
import Job from '../themes/job';
import JobPost from '../themes/jobPost';
import aboutUs from './../themes/aboutUs';
import blogDetail from './../themes/blogDetail';
import indexBlogDetail from './../themes/indexBlogDetail';
import privacityPolicy from './../themes/privacityPolicy';
import termsAndConditions from './../themes/termsAndConditions';


// importing all the themes
export default class Routes extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        <Router>
          <Switch>
            <Route exact path="/" component={Clientes} />
            {/* <Route exact path="/theme1" component={Theme1} /> */}
            <Route exact path="/clientes" component={Clientes} />
            <Route exact path="/aliados" component={Aliados} />
            {/* <Route exact path="/theme3" component={Theme3} />
            <Route exact path="/theme4" component={Theme4} />
            <Route exact path="/theme5" component={Theme5} /> */}
            {/* 
            <Route exact path="/login1" component={Login1} />
            <Route exact path="/login2" component={Login2} />
            <Route exact path="/signup1" component={SignUp1} />
            <Route exact path="/signup2" component={SignUp2} />
            <Route exact path="/resetPassword" component={ResetPassword} />
            <Route exact path="/changePassword" component={ChangePassword} />
            <Route exact path="/download" component={Download} />
            <Route exact path="/review" component={Review} />
            <Route exact path="/faq" component={Faq} />
            <Route exact path="/404" component={NotFound} />
            <Route exact path="/comingSoon" component={ComingSoon} />
            <Route exact path="/thankyou" component={ThankYou} /> */}
            {/* <Route exact path="/team" component={Team} />
            <Route exact path="/singleTeam" component={SingleTeam} />
            <Route exact path="/blogLeft" component={BlogLeft} /> */}
            {/* <Route exact path="/blog" component={Blog} /> */}
            <Route exact path="/blogRight" component={BlogRight} />
            <Route exact path="/equipo-frisbee" component={Job} />
            <Route exact path="/blog" component={indexBlogDetail} />
            <Route exact path="/blog/:date/:title/:entryID" component={blogDetail} />
            <Route exact path="/equipo-frisbee/:date/:title/:jobID" component={JobPost} />
            <Route exact path="/sobre-nosotros" component={aboutUs} />
            <Route exact path="/terminos-de-privacidad" component={privacityPolicy} />
            <Route exact path="/terminos-y-condiciones" component={termsAndConditions} />
          </Switch>
        </Router>
      </React.Fragment>
    );
  }
}
